import Galery from "./Galery";
import Summary from "./Summary";
import styles from "./index.module.scss";
import OutilsProject from "./OutilsProject";
import ReactMarkdown from "react-markdown";
import React, { useEffect, useRef } from "react";
import moment from "moment";
import "moment/locale/fr"
const BodyProject = ({ project, setImage }) => {
  moment.locale("fr");
  const bodyRef = useRef();

  useEffect(() => {
    let links = bodyRef.current.querySelectorAll("a");
    links.forEach((link) => {
      link.target = "_blank";
    });
  }, [project]);


  return (
    <article
      ref={bodyRef}
      className={styles.projectBody + " " + styles.gridLayout}
    >
      <aside className={styles.projectDates}>
        <p>
          Publié par <span itemProp="author">Axel G</span> le{" "}
          <time dateTime={project.createdAt} itemProp="datePublished" suppressHydrationWarning>
            {moment(project.createdAt).format("LL")}
          </time>
          . Mis à jour le{" "}
          <time dateTime={project.updatedAt} itemProp="dateModified" suppressHydrationWarning>
            {moment(project.updatedAt).format("LL")}
          </time>
          .
        </p>
      </aside>
      <Summary project={project} />
      <main className={styles.textContent} id="body-content">
        <ReactMarkdown  children={project.content}/>
      </main>
      <Galery project={project} setImage={setImage} />
      <aside className={styles.projectOutilMobile}>
        <OutilsProject project={project} />
      </aside>
    </article>
  );
};

export default BodyProject;
